import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, ActivationEnd, Params, Router } from '@angular/router';
import { filter, map, take, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/index';
import { OUTLAW_QUERY_PARAMS } from '../../consts/query-params';
import { OUTLAW_COOKIES } from '../../consts/cookie';
import { StorageService } from './storage.service';

export interface QueryParams {
  returnFilmId: number;
  returnPlaylistId: number;
  offerId: number;
  userToken: string;
  promocode: string;
  subscribe: boolean;
  uuid?: string;
}

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  private router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private storageService = inject(StorageService);

  readonly cookies = OUTLAW_COOKIES;
  readonly constQueryParams = OUTLAW_QUERY_PARAMS;

  get queryParams(): Params {
    return this.activatedRoute.snapshot.queryParams;
  }

  // todo one entry point with query + theme
  updateParams(_params: Params = null): void {
    let params = this.queryParams;
    if (_params) {
      params = _params;
    }

    this.updateSingleParam(this.constQueryParams.filmID, params);
    this.updateSingleParam(this.constQueryParams.playlistID, params);
    this.updateSingleParam(this.constQueryParams.subscribeAfter, params);
    this.updateSingleParam(this.constQueryParams.token, params);
    this.updateSingleParam(this.constQueryParams.promocode, params);
    this.updateSingleParam(this.constQueryParams.subscribe, params);
    this.updateSingleParam(this.constQueryParams.competitionID, params);

    this.removeOldPlaylistId();
  }

  private updateSingleParam(safeQueryParamsKey: string, params: Params): void {
    const value = params[safeQueryParamsKey];
    if (value) {
      // Pay attention on queryAndCookieRelation
      this.storageService.set(this.getQueryAndCookieRelation()[safeQueryParamsKey], value.toString());
    }
  }

  private removeOldPlaylistId(): void {
    const returnFilmId = this.storageService.get(this.cookies.return_film_id);
    const returnPlaylistId = this.storageService.get(this.cookies.return_playlist_id);

    if (returnFilmId && !returnPlaylistId) {
      this.storageService.remove(this.cookies.return_playlist_id);
    }
  }

  getParams(): Observable<QueryParams> {
    return this.router.events.pipe(
      filter(event => event instanceof ActivationEnd),
      take(1),
      tap(() => this.updateParams()),
      map(() => ({
        theme: this.storageService.get(this.cookies.theme),
        returnFilmId: this.storageService.get(this.cookies.return_film_id),
        returnPlaylistId: this.storageService.get(this.cookies.return_playlist_id),
        offerId: this.storageService.get(this.cookies.offer_id),
        userToken: this.storageService.get(this.cookies.user_token),
        promocode: this.storageService.get(this.cookies.promocode),
        subscribe: this.storageService.get(this.cookies.subscribe),
        competitionId: this.storageService.get(this.cookies.competition_to_buy),
        returnPostId: this.storageService.get(this.cookies.return_post_id),
        uuid: '',
      }))
    );
  }

  private getQueryAndCookieRelation(): Record<string, string> {
    return {
      [this.constQueryParams.filmID]: this.cookies.return_film_id,
      [this.constQueryParams.playlistID]: this.cookies.return_playlist_id,
      [this.constQueryParams.subscribeAfter]: this.cookies.offer_id,
      [this.constQueryParams.token]: this.cookies.user_token,
      [this.constQueryParams.promocode]: this.cookies.promocode,
      [this.constQueryParams.subscribe]: this.cookies.subscribe,
      [this.constQueryParams.competitionID]: this.cookies.competition_to_buy,
      [this.constQueryParams.postId]: this.cookies.return_post_id,
    };
  }
}
